import { render, staticRenderFns } from "./measurementPointBoxSorting.vue?vue&type=template&id=2fa38cc8&scoped=true"
import script from "./measurementPointBoxSorting.vue?vue&type=script&lang=js"
export * from "./measurementPointBoxSorting.vue?vue&type=script&lang=js"
import style0 from "./measurementPointBoxSorting.vue?vue&type=style&index=0&id=2fa38cc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa38cc8",
  null
  
)

export default component.exports